import { render, staticRenderFns } from "./PageSwiper.vue?vue&type=template&id=5879d241&scoped=true"
import script from "./PageSwiper.vue?vue&type=script&lang=js"
export * from "./PageSwiper.vue?vue&type=script&lang=js"
import style0 from "./PageSwiper.vue?vue&type=style&index=0&id=5879d241&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879d241",
  null
  
)

export default component.exports